<template>
  <v-dialog v-model="dialog" persistent max-width="490">
    <v-card class="px-2 py-2">
      <div class="d-flex align-center">
        <p class="text-left color-darkGray px-4 py-6" style="font-size: 18px">
          Atenção: ao REAGENDAR está a fazer um CANCELAMENTO para depois agendar novamente. Ao
          cancelar uma consulta com a forma de pagamento ''Multibanco'' a Stripe, banco responsável
          pelas transações do @Ondivan, irá entrar em contato consigo via e-mail para realizar o
          processo de retorno do valor. O valor terá uma percentagem descontada de 2.95% do valor da
          consulta e 0.25 cêntimos antes da devolução.
        </p>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="close"> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit('close');
    },
  },
};
</script>
